import ContactPickerStore from './schema/ContactPickerStore';
import { createStore } from 'satcheljs';

let contactPickerStoreData: ContactPickerStore = {
    contacts: [],
    isLoading: false,
    maxForSession: -1,
};

export let getStore = createStore<ContactPickerStore>('contactpicker', contactPickerStoreData);

var contactPickerStore = getStore();
export default contactPickerStore;
